import React, { useContext, useState } from "react";

import styles from "./WelcomeModal.module.scss";
import SecurityContext from "../Context/SecurityContext";
import { FiBookOpen, FiHome, FiUsers, FiFeather } from "react-icons/fi";
import { Button } from "../Inputs/Inputs";
import Modal from "../common/Modal/Modal";

const WelcomeModal = ({
  displayInfoModal,
  setDisplayInfoModal,
  setSeenWelcomeInfo,
  user,
}) => {
  const { api } = useContext(SecurityContext);

  const [termsAccepted, setTermsAccepted] = useState(false)
  const [firstClick, setFirstClick] = useState(false)

  const handleWelcomeInfo = () => {
    setFirstClick(true)

    if (termsAccepted === false) {
      return
    }

    const payLoad = {
      seen_welcome_info_at: user?.seen_welcome_info_at,
    };
    return api
      .seenWelcomeModal(payLoad)
      .then(data => {
        setSeenWelcomeInfo(data.seen_welcome_info_at);
        setDisplayInfoModal(false);
      })
      .catch(err => {
        if (err.errors) {
          setDisplayInfoModal(false);
        }
      });
  };

  if (!displayInfoModal) return null;

  return (
    <Modal>
      <h1>Tervetuloa Hetaan</h1>

      <div className={styles.infoContainer}>
        <div className={styles.iconWrapper}>
          <FiHome className={styles.infoIcon} />
        </div>
        <p>
          <strong>Kotisivulla</strong> näet Hekan ja talotoimikunnan
          ajankohtaisia tiedotuksia
        </p>
        <div className={styles.iconWrapper}>
          <FiBookOpen className={styles.infoIcon} />
        </div>
        <p>
          <strong>Asukkaan oppaasta</strong> löydät tietoja ja neuvoja asumiseen
        </p>
        <div className={styles.iconWrapper}>
          <FiUsers className={styles.infoIcon} />
        </div>
        <p>
          <strong>Oma talo</strong> -sivulla voit osallistua yhteisösi
          toimintaan vastaamalla talotoimikunnan kyselyihin ja tekemällä
          ehdotuksia
        </p>
        <div className={styles.iconWrapper}>
          <FiFeather className={styles.infoIcon} />
        </div>
        <p>
          <strong>Ekoekspertissä</strong> keräät pisteitä itsellesi ja
          yhteisöllesi suorittamalla eko-teemaisia haasteita
        </p>
      </div>

      <div className={styles.terms}>
        <div>
          <input type="checkbox"
            onChange={() => {
              setTermsAccepted(!termsAccepted)
            }}
            checked={termsAccepted}
          />

          <div>
            Hyväksyn palvelun{" "}
            <a href="https://www.hekaoy.fi/fi/heta-sovelluksen-kayttoehdot-hekan-asukkaille" target="_blank">käyttöehdot</a>
          </div>
        </div>

        {(termsAccepted === false && firstClick === true) && (
          <p>Ehdot täytyy hyväksyä!</p>
        )}
      </div>

      <div className={styles.modalButton}>
        <Button tealButton onClick={handleWelcomeInfo}>
          Jatka sovellukseen
        </Button>
      </div>
    </Modal>
  );
};

export default WelcomeModal;
